import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.deviceData ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_vm.deviceData.tags ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, _vm._l(_vm.deviceData.tags.split(','), function (item, i) {
    return _c(VChip, {
      key: i,
      staticClass: "ma-1"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")]);
  }), 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01 px-0 py-0 mt-8 mb-0",
    attrs: {
      "icon": "fa-file-alt",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.generally'),
      "offset": 24
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "3",
      "sm": "6",
      "lg": "3",
      "xl": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'code',
      "label": _vm.$i18n_t('NiotaClassic.Applications.table.eui'),
      "value": _vm.deviceData.eui,
      "copy": true
    }
  })], 1), _vm.applicationTitle ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2",
      "xl": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'link',
      "link": _vm.applicationLink,
      "redirect": true,
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.application'),
      "value": _vm.applicationTitle
    }
  })], 1) : _vm._e(), _vm.deviceTypeTitle ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2",
      "xl": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'link',
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "link": _vm.deviceTypeLink,
      "redirect": true,
      "value": _vm.deviceTypeTitle
    }
  })], 1) : _vm._e(), _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2",
      "xl": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.originator'),
      "value": _vm.deviceData.originator.title
    }
  })], 1), _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Common.table.createdAt'),
      "value": _vm.localizeDate(_vm.deviceData.createdAt)
    }
  })], 1), _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2",
      "xl": "2"
    }
  }, [(_vm.deviceData.originator.datasource.type === 'firefly_mqtt' || _vm.deviceData.originator.datasource.type === 'firefly') && !_vm.status ? _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.signal'),
      "value": _vm.$i18n_t('NiotaClassic.Devices.details.statusErrorMsg'),
      "iconColor": _vm.getColor('error'),
      "icon": "sensor-alert",
      "type": "icon"
    }
  }) : _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.signal'),
      "value": _vm.getRssiValue(),
      "icon": _vm.rssiIcon,
      "iconColor": _vm.color,
      "type": "icon"
    }
  })], 1), _vm.deviceData.originator.datasource.type === 'firefly_mqtt' || _vm.deviceData.originator.datasource.type === 'firefly' ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "1",
      "sm": "6",
      "lg": "2",
      "xl": "1"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.status'),
      "icon": _vm.status ? 'check' : 'times',
      "iconColor": _vm.status ? _vm.color : _vm.getColor('error'),
      "type": "icon"
    }
  })], 1) : _vm._e(), (_vm.deviceData.originator.datasource.type === 'firefly_mqtt' || _vm.deviceData.originator.datasource.type === 'firefly') && _vm.remoteLink ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2",
      "xl": "1"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'link',
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.link'),
      "link": _vm.remoteLink,
      "iconColor": _vm.color,
      "itemImage": _vm.deviceData.originator.datasource.image ? _vm.niota1ImageUrl(_vm.deviceData.originator.datasource.image) : null
    }
  })], 1) : _vm._e(), (_vm.deviceData.originator.datasource.type === 'firefly_mqtt' || _vm.deviceData.originator.datasource.type === 'firefly') && !_vm.remoteLink ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "1",
      "sm": "6",
      "lg": "2",
      "xl": "1"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.link'),
      "iconColor": _vm.getColor('error'),
      "icon": "unlink",
      "type": "icon"
    }
  })], 1) : _vm._e(), _vm.deviceData.properties && _vm.deviceData.properties.motionIndicator ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "1",
      "sm": "6",
      "lg": "2",
      "xl": "1"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.motionIndicator'),
      "value": _vm.deviceData.properties.motionIndicator
    }
  })], 1) : _vm._e(), (_vm.deviceData.originator.datasource.type === 'firefly_mqtt' || _vm.deviceData.originator.datasource.type === 'firefly') && _vm.deviceData.properties ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "6",
      "lg": "3",
      "xl": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.region'),
      "icon": "globe",
      "type": "icon",
      "value": _vm.getRegionText(_vm.deviceData)
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-align-left",
      "title": _vm.$i18n_t('NiotaClassic.Devices.details.description'),
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.deviceData.description || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)]), _vm.deviceData.application_session_key || _vm.deviceData.network_session_key || _vm.deviceData.application_key || _vm.deviceData.address ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-key-skeleton",
      "title": _vm.$i18n_t('NiotaClassic.Devices.details.accessAndSecProp'),
      "offset": 24
    }
  }, [_c(VRow, [_vm.deviceData.application_session_key ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "4",
      "xl": "3"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'code',
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.appSessionKey'),
      "value": _vm.deviceData.application_session_key
    }
  })], 1) : _vm._e(), _vm.deviceData.network_session_key ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "4",
      "xl": "3"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'code',
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.networkSessionKey'),
      "value": _vm.deviceData.network_session_key
    }
  })], 1) : _vm._e(), _vm.deviceData.application_key ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "4",
      "xl": "3"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'code',
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.applicationKey'),
      "value": _vm.deviceData.application_key
    }
  })], 1) : _vm._e(), _vm.deviceData.properties && _vm.deviceData.properties.applicationEUI ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "4",
      "xl": "3"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'code',
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.applicationEui'),
      "value": _vm.deviceData.properties.applicationEUI
    }
  })], 1) : _vm._e(), _vm.deviceData.address ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "4",
      "xl": "3"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'code',
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.address'),
      "value": _vm.deviceData.address,
      "copy": true
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-battery-full",
      "title": _vm.$i18n_t('NiotaClassic.Devices.details.status'),
      "offset": 24
    }
  }, [_c(VRow, [_vm.operationalStatus(_vm.deviceData) ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.operationalStatus'),
      "value": _vm.operationalStatus(_vm.deviceData)
    }
  })], 1) : _vm._e(), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.battery_level ? _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.battery'),
      "value": _vm.getBatteryLevel(),
      "iconColor": _vm.color,
      "icon": "battery-bolt",
      "type": "icon"
    }
  }) : _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.battery'),
      "iconColor": _vm.color,
      "icon": "battery-slash",
      "type": "icon"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.battery_warning ? _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.warningLevel'),
      "value": _vm.getBatteryWarningLevel(),
      "iconColor": _vm.getColor('warning'),
      "icon": "siren-on",
      "type": "icon"
    }
  }) : _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.warningLevel'),
      "value": _vm.getBatteryWarningLevel(),
      "iconColor": _vm.color,
      "icon": "siren",
      "type": "icon"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.battery_warning ? _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.alertLevel'),
      "value": _vm.getBatteryAlertLevel(),
      "iconColor": _vm.getColor('error'),
      "icon": "sensor-alert",
      "type": "icon"
    }
  }) : _c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.alertLevel'),
      "value": _vm.getBatteryAlertLevel(),
      "iconColor": _vm.color,
      "icon": "siren",
      "type": "icon"
    }
  })], 1)], 1), _vm.deviceData.properties && _vm.deviceData.properties.extraFields && _vm.deviceData.properties.extraFields.length ? _c(VRow, _vm._l(_vm.deviceData.properties.extraFields, function (field, key) {
    return _c(VCol, {
      key: key,
      staticClass: "mb-0 mt-0 pt-0",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('custom-fields-display-field', {
      attrs: {
        "label": field.name,
        "value": field.value,
        "icon": field.icon,
        "iconColor": _vm.color,
        "type": "icon"
      }
    })], 1);
  }), 1) : _vm._e()], 1), _vm.devicePackets.length && (_vm.deviceData.properties && _vm.deviceData.properties.enable_SFGraph || _vm.deviceData.properties.enable_statistics) ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-chart-bar",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.statistics'),
      "offset": 24
    }
  }, [_c('niota-classic-devices-device-details-statistics', {
    attrs: {
      "deviceData": _vm.deviceData,
      "periodStatistics": _vm.period_statistics,
      "periodOlderStatistics": _vm.period_older_statistics,
      "packetsIncreaseRatio": _vm.packets_increase_ratio,
      "sendingRate": _vm.sending_rate,
      "validStatistics": _vm.validStatistics
    },
    on: {
      "select-metrics-length": _vm.selectMetricsLength
    }
  }), _vm.deviceData.properties && _vm.deviceData.properties.enable_SFGraph ? _c(VRow, [_vm.hourlyPacketsgraph.individual && _vm.hourlyPacketsgraph.individual.length ? _c(VCol, {
    staticClass: "charts-min-height",
    attrs: {
      "cols": "12"
    }
  }, [!_vm.isLoadingMetrics ? _c('niota-classic-charts-bar', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.hourlyPacketsgraph,
      "options": _vm.hourlyPacketsgraphOptions
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  })], 1) : _vm._e(), _vm.snrGraph.individual && _vm.snrGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.rssiSnr')))])])])], 1)], 1), !_vm.isLoadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.snrGraph
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e(), _vm.spreadingFactorGraph.individual && _vm.spreadingFactorGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.spreadingFactor')) + " (" + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.average')) + ": " + _vm._s(_vm.spreading_factor_average) + ")\n                ")])])])], 1)], 1), !_vm.isLoadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.spreadingFactorGraph,
      "options": _vm.spreadingFactorGraphOptions
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm.size(_vm.get(_vm.deviceData, 'deviceType.properties.downlinks')) && _vm.startsWith(_vm.get(_vm.deviceData, 'originator.datasource.type'), 'firefly') ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-level-down-alt",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.downlinks'),
      "offset": 24
    }
  }, [_c('niota-classic-devices-device-details-downlinks', {
    attrs: {
      "deviceData": _vm.deviceData
    },
    on: {
      "select-metrics-length": _vm.selectMetricsLength
    }
  })], 1) : _vm._e(), _vm.startsWith(_vm.get(_vm.deviceData, 'originator.datasource.type'), 'actility') ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-level-down-alt",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.downlinksActility'),
      "offset": 24
    }
  }, [_c('niota-classic-devices-device-details-downlinksActility', {
    attrs: {
      "deviceData": _vm.deviceData
    },
    on: {
      "select-metrics-length": _vm.selectMetricsLength
    }
  })], 1) : _vm._e(), _vm.devicePackets.length ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-box",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.packets'),
      "offset": 24
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0 mb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-date-time-picker', {
    staticClass: "mt-0",
    attrs: {
      "from": _vm.start / 1000
    },
    on: {
      "date:picked": _vm.datePicked
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0 mb-0",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c(VSwitch, {
    attrs: {
      "inset": "",
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.switchDate')
    },
    model: {
      value: _vm.switchDate,
      callback: function ($$v) {
        _vm.switchDate = $$v;
      },
      expression: "switchDate"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('niota-classic-devices-lists-packet-list', {
    attrs: {
      "items": _vm.devicePackets,
      "datasourceType": _vm.datasourceType,
      "switchDate": _vm.switchDate
    }
  }), _vm.devicePackets.length >= 10 ? _c('div', {
    staticClass: "text-center"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('NiotaClassic.Devices.table.loadMore'),
      "loading": _vm.packetsLoading,
      "disabled": _vm.packetsLoading || _vm.btnDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('load-more-packets');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.loadMore')) + "\n          ")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };